import { Button } from '@/components/ui/button'
import { IconPlus, IconPlugConnected } from '@tabler/icons-react'
import { selectSetOpen, useConnectionStore } from '../store'

export function EmptyState() {
  const setOpen = useConnectionStore(selectSetOpen)

  return (
    <div className='text-center py-12 border rounded-lg bg-gray-50 dark:bg-background'>
      <div className='mx-auto w-12 h-12 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center mb-4'>
        <IconPlugConnected className='w-6 h-6 text-gray-400' />
      </div>
      <h3 className='text-lg font-medium mb-1'>Nenhuma conexão encontrada</h3>
      <p className='text-sm text-gray-500 mb-4'>
        Comece criando sua primeira conexão com o WhatsApp
      </p>
      <Button onClick={() => setOpen('create')}>
        <IconPlus className='w-4 h-4 mr-2' />
        Adicionar WhatsApp
      </Button>
    </div>
  )
}
